import { PortalModule } from '@angular/cdk/portal';
import { NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, HostListener, OnDestroy, OnInit, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Subject } from 'rxjs';
import { take } from 'rxjs/operators';
import { DialogService, FeedbackService, FlyoutService, NavigationService } from '@app/core/services';
import { BaseFlyoutComponent } from '@app/shared/components';
import { FileUploadComponent } from '@app/shared/components/file-upload/file-upload.component';
import { UploadedFileModel } from '@app/shared/components/file-upload/models/uploaded-file.model';
import { ImportInvoiceModel } from '../../interfaces/import-invoice-model';
import { ImportPcardService } from '../../services/import-pcard.service';

@Component({
	selector: 'sl-import-pcard',
	templateUrl: './import-pcard.component.html',
	styleUrls: ['./import-pcard.component.less'],
	standalone: true,
	imports: [MatButtonModule, PortalModule, MatIconModule, FileUploadComponent, NgIf, NgFor],
})
export class ImportPcardComponent extends BaseFlyoutComponent implements OnInit, OnDestroy {
	@Output()
	newDataEvent = new EventEmitter<ImportInvoiceModel>();

	public allowedExtensions = ['csv'];
	public buttonText = 'Choose Spreadsheet File For Import (CSV)';

	public header = 'Import Payment Card File';

	public data: ImportInvoiceModel = null;
	public file: UploadedFileModel;

	private readonly destroy$ = new Subject();

	constructor(
		protected navigationService: NavigationService,
		protected dialog: MatDialog,
		protected readonly dialogService: DialogService,
		protected readonly flyoutService: FlyoutService,
		protected readonly feedbackService: FeedbackService,
		private readonly importPcardService: ImportPcardService
	) {
		super(flyoutService, dialogService);
	}

	@HostListener('window:beforeunload')
	canDeactivate = (): boolean => true;

	ngOnInit(): void {
		this.data = null;
	}

	ngOnDestroy(): void {
		this.destroy$.next(undefined);
		this.destroy$.complete();
	}

	closeFlyout(): void {
		this.close()
			.pipe(take(1))
			.subscribe((closed) => {
				if (closed) {
					this.clearData();
				}
			});
	}

	fileChangeEvent(uploadedFile: UploadedFileModel): void {
		this.file = uploadedFile;
	}

	parseCsvToList(): void {
		this.getList();
	}

	private clearData(): void {
		this.data = null;
		this.file = null;
	}

	private getList(): void {
		const listObservable = this.importPcardService.import(this.file);
		listObservable.subscribe((data: ImportInvoiceModel) => {
			this.data = data;
			if (data.Succeeded === false) {
				return;
			}

			this.feedbackService.success('imported', 'Payment Card File');
			this.newDataEvent.emit(this.data);
			this.closeFlyout();
		});
	}
}
